import {BASESITEID} from '../components/common/constants';
export const getCreateEquityApiEndpoint = `/occ/v2/${localStorage.getItem(
    'baseSiteId'
) ? localStorage.getItem(
    'baseSiteId'
) : BASESITEID}/order/equity`;

export const getEquityProductSearchEndpoint = (queryParams) =>
    `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/products/productList?${queryParams}`;

export const getEquityValidatedProducts = `occ/v2/${localStorage.getItem(
    'baseSiteId'
)}/products/validateproduct?`;

export const getValidateMazorCodeEndpoint = (code) =>
    `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/order/usage/validatemazorcode?mazorKitCode=${code}`;

export const getEquityCategoryAndBrandsApiEndpoint = (territoryIdValue) => `/occ/v2/${localStorage.getItem(
    'baseSiteId'
) ? localStorage.getItem(
    'baseSiteId'
) : BASESITEID}/products/productBrandAndCategoryList?orderType=ZOR&territoryId=${territoryIdValue}`;

export const getEquityProductsByBrandOrSuperCategoryApiEndpoint = (
    queryParams
) =>
    `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/products/productDetailsByFacetCategoryBrand?${queryParams}`;

export const getProductDetailsApiEndpoint = (
    productCFN,
    salesOrg,
    orderType,
    resourceType
) =>
    `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/products/productDetails/${productCFN}?salesOrg=${salesOrg}&orderType=${orderType}&resourceType=${resourceType}`;

export const getValidatedProductsEndpoint =(queryParams)=> `occ/v2/${localStorage.getItem(
    'baseSiteId'
)}/products/validateproduct?${queryParams}`;

export const getDetailedEquityProductTemplatesEndpoint = (queryParams) => 
    `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/productTemplates/templateslist?${queryParams}`;

export const getEquityTemplateDetailsEndpoint = (queryParams) => 
    `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/productTemplates/templatesdetails/${queryParams}`;

export const createEquityProductTemplateEndpoint = 
    `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    ) ? localStorage.getItem(
        'baseSiteId'
    ) : BASESITEID}/templates`;

export const updateEquityProductTemplateEndpoint = 
    `/occ/v2/${localStorage.getItem('baseSiteId')}/templates`;

export const getDataForEquityTemplateEndpoint = (myCASERef, templateType) => 
    `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/productTemplates/templatesdetails/${
        myCASERef
    }?isMyCASERef=true&templateType=${templateType}`;

export const getPricesForItemsEndpoint = (queryParams) =>
    `occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/order/usage/price?${queryParams}`;

export const getDropdownEnpoint = (dropdown) => {
    const url = `/occ/v2/${localStorage.getItem('baseSiteId')}/order/`;
    switch (dropdown) {
        case 'priceoverridereasons':
            return `${url}priceoverridereasons?orderType=ZOR`;
        case 'procedures':
            return `${url}Surgery/procedure`;
        default:
            return '';
    }
};
    